import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../components/Common/Index.style'
import { no159Style } from '../../../components/Article/No159.style'
import Page from '../../../components/Page/Page'
import PageHeader from '../../../components/PageHeader/PageHeader'
import Content from '../../../components/Content/Content'
import SectionTitle from '../../../components/SectioinTitle'
import BackBtn from '../../../components/Common/BackBtn'
import BreadCrumb from '../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '2022お出かけイベント情報 | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="にいがたイベントガイド" />
      <SectionTitle sectionTitle="2022お出かけイベント情報" />
      <Content css={style.content}>
        <BreadCrumb
            lists={[
              {
                name: "HOME",
                path: "/"
              },
              {
                name: "2022初秋号 No.159 目次",
                path: "/no159"
              },
              {
                name: "イベントガイド"
              }
            ]}
          />
        <p>イベントなどは急きょ中止や変更となる場合があります。詳細は各施設にご確認ください。</p>
        
        <h3 css={style.subTitle01}>一緒にお泊まりキャンプinたいない</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>11/5（土）～6（日）</h4>
        <p>対象：園児（年中・年長）とその保護者<br />
          定員：34組程度<br />
          料金：3,500円（活動内容により変更することがあります）<br />
          申込期間：9/1（木）～10/4（火）</p>
          <p><span css={no159Style.eventAddr}>【問い合わせ】県少年自然の家（胎内市）</span>&emsp;電話：<a href="tel:0254-46-2224">0254-46-2224</a><br />ホームページは<a href="https://www.pref.niigata.lg.jp/site/shizen/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no159/img/2-6.png`}
          alt="買い物チャレンジ"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>買い物チャレンジ</p>
        <hr />
        
        
        <h3 css={style.subTitle01}>新潟県展を育てた審査員たち展</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>9/8（木）まで 9:30～16:30</h4>
        <p>休館：9/5（月）<br />料金：［当日］一般1,000円、中学・高校・大学生800円</p>
          <p><span css={no159Style.eventAddr}>【問い合わせ】県民会館（新潟市中央区）</span>&emsp;電話：<a href="tel:025-228-4481">025-228-4481</a><br />ホームページは<a href="https://www.niigata-kenminkaikan.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no159/img/2-7.png`}
          alt="岩田正巳≪良寛禅師≫1983"
          css={style.img(300, "15px 0 0 0")}
        />
        <p css={style.imgCap}>岩田正巳<br />≪良寛禅師≫1983</p>
        <hr />
        
        <h3 css={style.subTitle01}>庵野秀明展</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>9/23日（金・祝）～1/9（月・祝）</h4>
        <p>休館：月（10/10、11/14、12/26、1/9は開館）<br />
          料金：一般1,700円、高校・大学生1,300円<br />
          ※障害者手帳をお持ちの方は無料</p>
          <p><span css={no159Style.eventAddr}>【問い合わせ】県立万代島美術館（新潟市中央区）</span>&emsp;電話：<a href="tel:025-290-6655">025-290-6655</a><br />ホームページは<a href="https://banbi.pref.niigata.lg.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no159/img/2-8.png`}
          alt="東京会場の様子（提供：庵野秀明展実行委員会）"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>東京会場の様子（提供：庵野秀明展実行委員会）</p>
        <hr />
        
        <h3 css={style.subTitle01}>食虫植物展</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>9/19（月・祝）まで</h4>
        <p>休館：月（祝日の場合は翌平日）<br />
          観賞温室入館料：一般600円、65歳以上500円、高校・大学生300円、小・中学生100円（土日祝日は小・中学生無料）</p>
          <p><span css={no159Style.eventAddr}>【問い合わせ】県立植物園（新潟市秋葉区）</span>&emsp;電話：<a href="tel:0250-24-6465">0250-24-6465</a><br />ホームページは<a href="https://botanical.greenery-niigata.or.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no159/img/2-9.png`}
          alt="食虫植物展"
          css={style.img(300, "15px 0 0 0")}
        />
        
        <hr />
        
        <h3 css={style.subTitle01}>ぶっとんでるいきもの展２</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>8/28（日）まで 9:30～17:00</h4>
        <p>休館：火（祝日の場合は翌平日）、但し、8/23は開館<br />
          料金（入館料込み）：一般1,480円、小・中学生700円</p>
          <p><span css={no159Style.eventAddr}>【問い合わせ】県立自然科学館（新潟市中央区）</span>&emsp;電話：<a href="tel:025-283-3331">025-283-3331</a><br />ホームページは<a href="https://www.sciencemuseum.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no159/img/2-10.png`}
          alt="ぶっとんでるいきもの展２"
          css={style.img(500, "15px 0 0 0")}
        />

        <hr />
        
        <h3 css={style.subTitle01}>Ｗ．ユージン・スミスとアイリーン・Ｍ．スミス写真展</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>9/17（土）～10/10（月・祝）</h4>
        <p>休館：月（祝日の場合は翌平日）</p>
          <p><span css={no159Style.eventAddr}>【問い合わせ】環境と人間のふれあい館（新潟市北区）</span>&emsp;電話：<a href="tel:025-387-1450">025-387-1450</a><br />ホームページは<a href="http://www.fureaikan.net/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no159/img/2-11.png`}
          alt="撮影：Ｗ.ユージン・スミス ©アイリーン・美緒子・スミス"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>撮影：Ｗ.ユージン・スミス<br />&copy;アイリーン・美緒子・スミス</p>
        <hr />
        
        <h3 css={style.subTitle01}>こうなんふれ愛まつり</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>10/9（日） 10:00～14:00</h4>
        <p>内容：フリーマーケット、ステージ発表、屋台など</p>
          <p><span css={no159Style.eventAddr}>【問い合わせ】新潟ふれ愛プラザ（新潟市江南区）</span>&emsp;電話：<a href="tel:025-381-8110">025-381-8110</a><br />ホームページは<a href="https://n-fureaiplaza.com/" target="_blank" rel="noreferrer">こちら</a></p>
        <hr />
        
        <h3 css={style.subTitle01}>佐渡金銀山を世界遺産に！GoGoフェスタ2022</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>9/23（金・祝）</h4>
        <p>内容：佐渡金銀山に関するステージイベントなど</p>
          <p><span css={no159Style.eventAddr}>【問い合わせ】新潟ふるさと村（新潟市西区）</span>&emsp;電話：<a href="tel:025-230-3030">025-230-3030</a><br />ホームページは<a href="http://furusatomura.pref.niigata.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no159/img/2-12.png`}
          alt="佐渡金銀山を世界遺産に！GoGoフェスタ2022"
          css={style.img(500, "15px 0 0 0")}
        />
        
        <hr />
        
        <h3 css={style.subTitle01}>三沢厚彦 ANIMALS IN NAGAOKA</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>9/25（日）まで</h4>
        <p>休館：月（祝日の場合は翌平日）<br />
          料金：一般1,400円、高校・大学生1,200円<br />
          ※障害者手帳をお持ちの方は無料</p>
          <p><span css={no159Style.eventAddr}>【問い合わせ】県立近代美術館（長岡市）</span>&emsp;電話：<a href="tel:0258-28-4111">0258-28-4111</a><br />ホームページは<a href="https://kinbi.pref.niigata.lg.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no159/img/2-13.png`}
          alt="三沢厚彦《Painting 2022-03》"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>三沢厚彦《Painting 2022-03》2022 パネル、アクリル<br />
        撮影／三沢厚彦<br />
        &copy;Atsuhiko Misawa,Courtesy of Nishimura Gallery</p>
        <hr />
        
        <h3 css={style.subTitle01}>生業絵巻尽―ひらけ！江戸の産業図鑑―</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>9/17（土）～10/30（日）</h4>
        <p>休館：月（祝日の場合は翌平日）<br />
          料金：一般840円、高校・大学生600円</p>
          <p><span css={no159Style.eventAddr}>【問い合わせ】県立歴史博物館（長岡市）</span>&emsp;電話：<a href="tel:0258-47-6130">0258-47-6130</a><br />ホームページは<a href="http://nbz.or.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no159/img/2-14.png`}
          alt="佐渡金銀山絵巻（当館蔵）"
          css={style.img(300, "15px 0 0 0")}
        />
        <p css={style.imgCap}>佐渡金銀山絵巻（当館蔵）</p>
        <hr />
        
        <h3 css={style.subTitle01}>猫の飼い方セミナー</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>10/2（日） 9:30～11:30</h4>
        <p>定員：20人（申込先着順）</p>
          <p><span css={no159Style.eventAddr}>【問い合わせ】県動物愛護センター（長岡市）</span>&emsp;電話：<a href="tel:0258-21-5501">0258-21-5501</a><br />ホームページは<a href="https://www.pref.niigata.lg.jp/site/da-top/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no159/img/2-15.png`}
          alt="猫の飼い方セミナー"
          css={style.img(500, "15px 0 0 0")}
        />
        
        <hr />
        
        <h3 css={style.subTitle01}>森の工作教室</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>開園期間中の土日祝日</h4>
        <p>休館：11月上旬までは無休</p>
          <p><span css={no159Style.eventAddr}>【問い合わせ】県立浅草山麓エコ・ミュージアム（魚沼市）</span>&emsp;電話：<a href="tel:025-798-4141">025-798-4141</a><br />ホームページは<a href="http://www.eco-museum.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <hr />
        
        <h3 css={style.subTitle01}>こども自然王国 9月からの体験</h3>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>●工作・ウォークラリー</h4>
        <p>毎週土日祝日</p>
        <h4 css={[style.subTitle02,no159Style.eventDate]}>●親子トンボとり大作戦！</h4>
        <p>10/2（日） 9:30～12:30</p>
        <p>料金：親子１組1,000円<br />お電話にてお申し込みください。</p>
        <p><span css={no159Style.eventAddr}>【問い合わせ】県立こども自然王国（柏崎市）</span>&emsp;電話：<a href="tel:0257-41-3355">0257-41-3355</a><br />ホームページは<a href="https://www.garuru-kururu.jp/" target="_blank" rel="noreferrer">こちら</a></p>
        
        <img
          src={`${basePath}/no159/img/2-16.png`}
          alt="親子トンボとり大作戦！"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>親子トンボとり大作戦！</p>
        
        <BackBtn href={"/no159"} />
      </Content>
    </Page>
  )
}
export default Home
